module.exports = __webpack_public_path__ + "img/pr-12.307702b5.png";